export default import.meta.ROLLDOWN_FILE_URL_oo3vkZbg$oFIiT8$lRAxcA